import { ParentMixin as o } from "../mixins/relation.js";
import { createNamespace as a } from "../utils/create/index.js";
var e = a("goods-action"),
  r = e[0],
  n = e[1];
var c = r({
  mixins: [o("vanGoodsAction")],
  props: {
    safeAreaInsetBottom: {
      type: Boolean,
      default: !0
    }
  },
  render: function render() {
    var t = arguments[0];
    return t("div", {
      class: n({
        unfit: !this.safeAreaInsetBottom
      })
    }, [this.slots()]);
  }
});
export { c as default };
